import './LeadSources.scss'

import React, { Component } from 'react';

import Table from 'common/views/atoms/Table/Table'
import ReactTooltip from 'react-tooltip'
import { show as showModal } from 'redux-modal'
import cx from 'bem-classnames'
import { FilteredList } from 'broker/views/components/common/Filter/FilteredList'

import moment from 'moment-timezone'

import {
  labelFor,
  prettyShortNumber
} from 'common/util/helper'

import {
  getTimeframeFromFilterList,
  getQueriesFromFilterList,
  exportSearchFiltersForSegment,
  filtersWithValues
} from 'broker/util/helper'

import {
  LEAD_SOURCE_EXPORT_TIMEFRAME, LEAD_SOURCE_HIGH_CUT_OFF, LEAD_SOURCE_LOW_CUT_OFF, PRICE, LEAD_TYPE,
  BUYER_TYPE, US_STATES, BROKER_LEAD_STAGES, SHORT_LEAD_TYPE, LEAD_TYPE_OPTIONS
} from 'common/constants'

import {
  fetchLeadSources, masqueradeAgent, searchLeadSources, fetchSourceTypes, fetchStates, fetchMarkets, fetchAgents
} from 'broker/redux/account'

import ProgressCircle from 'common/views/components/ProgressCircle'
import LeadSourceDetailModal from './LeadSourceDetailModal'
import LeadInquiryInfoModal from './LeadInquiryInfoModal'

import { segmentEventTracker } from 'common/analytics'
import {GenericLeadsDownloader} from "broker/util/downloader"
import DownloadModal from "broker/views/components/common/DownloadModal"
import _ from "lodash"

const LeadSourceTablet = (props) => {
  const { dispatch } = props

  const ecr = (props.ecr ? props.ecr : 0.0) * 100
  const showEcr = (props.pipeline && props.pipeline['total']) || 0 > 0
  const categorization = showEcr ? (ecr > LEAD_SOURCE_HIGH_CUT_OFF ? 'high' : ecr < LEAD_SOURCE_LOW_CUT_OFF ? 'low' : 'average') : 'none'

  const triangleClasses = {
    name: 'LeadSourceTablet__triangle',
    modifiers: ['high', 'average', 'low', 'none']
  }
  const titleClasses = {
    name: 'LeadSources__modal--header--title',
    modifiers: ['extra-padding']
  }

  const nameKey = props.name_key ? props.name_key : 'other'
  const name = props.name ? props.name : 'Other Sources'
  const logoClasses = ['LeadSourceTablet__title-sec--logo', `LeadSourceTablet__title-sec--logo--${nameKey}`]

  return (
    <div className="LeadSourceTablet" onClick={() => {
      dispatch(showModal('LeadSourceDetailModal', {...props}))

      segmentEventTracker('Modal Shown', {
        'modal_name': 'LeadSourceTablet',
        'lead_source_name': name,
        'lead_source_type_id': props.lead_source_type_id,
        'lead_source_is_confirmed_quality': props.is_confirmed_quality,
        'lead_source_array_placement': props.leadSourceArrayIdx,
        'lead_source_performance_categorization': categorization,
        'lead_source_is_active': props.is_active
      })
    }}>
      <div className={cx(triangleClasses, {[categorization]: true})}/>
      <div className="LeadSourceTablet__title-sec">
        <div className={logoClasses.join(' ')}>
          <div style={{backgroundImage: `url(${props.logo_url})`}}>{!props.logo_url ? <div>OS</div> : null }</div>
        </div>
        <div className="pull-left">
          <div className={cx(titleClasses, {['extra-padding']: !props.is_confirmed_quality})}>{name}</div>
          { props.is_confirmed_quality ? <div className="LeadSourceTablet__title-sec--confirmed"><i className="fa fa-check-circle"/> Confirmed Quality</div> : null }
        </div>
        <div className="LeadSourceTablet__title-sec--activity">
          { !props.is_active ? <div className="LeadSourceTablet__title-sec--inactive"><span>Inactive</span></div> : null }
        </div>
      </div>

      <div className="LeadSourceTablet__content-sec">
        {
          showEcr ? <div>
            <ProgressCircle
              type='lead-sources'
              value={ecr}
              categorization={categorization}
              scaleMin={0}
              scaleMax={LEAD_SOURCE_HIGH_CUT_OFF + 1.5}
            />
            <div className="LeadSourceTablet__content-sec--label">Expected Close Rate <i className="fa fa-question-circle" data-tip="Projections based on Opcity data" /></div>
          </div> : <div>
            <div className="LeadSourceTablet__content-sec--house"/>
            <div className="LeadSourceTablet__content-sec--label--large">No leads referred yet.</div>
            <div className="LeadSourceTablet__content-sec--label--gray">Check back soon.</div>
          </div>
        }

        <hr />

        <div className="LeadSourceTablet__content-sec--label left-align">Leads Received</div>
        <div>
          <div className="LeadSourceTablet__content-sec--data">
            <label>All-Time</label>
            <div className={!props.all_time_summary.lead_count ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{props.all_time_summary.lead_count || '—'}</div>
          </div>
          <div className="LeadSourceTablet__content-sec--data">
            <label>Avg Prop. Value</label>
            <div className={!props.all_time_summary.avg_price ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.all_time_summary.avg_price, true)}</div>
          </div>
        </div>

        <hr />

        <div className="LeadSourceTablet__content-sec--label left-align">Transaction Volume</div>
        <div>
          <div className="LeadSourceTablet__content-sec--data-3">
            <label>Closed</label>
            <div className={!props.internal && !props.external ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{(props.internal || 0) + (props.external || 0)}</div>
          </div>
          <div className="LeadSourceTablet__content-sec--data-3">
            <label>Volume</label>
            <div className={!props.internal_closes_to_date && !props.external_closes_to_date ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber((props.internal_closes_to_date || 0) + (props.external_closes_to_date || 0) , true)}</div>
          </div>
          <div className="LeadSourceTablet__content-sec--data-3">
            <label>Forecast</label>
            <div className={!props.forecast ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.forecast, true)}</div>
          </div>
        </div>

        <hr />

        <div className="LeadSourceTablet__content-sec--label left-align">Earnings</div>
        { props.internal || props.external ? <div className="left-align">
          <div className="LeadSourceTablet__content-sec--data" style={{paddingRight: 22}}>
            <label className="LeadSourceTablet__content-sec--earning-label">Your Referrals</label>

            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Closed</label>
              <div className={!props.internal ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{(props.internal || 0)}</div>
            </div>
            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Commissions</label>
              <div className={!props.internal_commission ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.internal_commission, true)}</div>
            </div>
          </div>
          { props.spilloverEnabled ? <div className="LeadSourceTablet__content-sec--data" style={{paddingLeft: 22, borderLeftWidth: 1, borderLeftColor: '#dddddd', borderLeftStyle: 'solid'}}>
            <label className="LeadSourceTablet__content-sec--earning-label">Network Referrals</label>

            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Closed</label>
              <div className={!props.external ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{(props.external || 0)}</div>
            </div>
            <div className="LeadSourceTablet__content-sec--data-small">
              <label>Payments</label>
              <div className={!props.external_commission ? 'LeadSourceTablet__content-sec--data-lighter' : null }>{prettyShortNumber(props.external_commission, true)}</div>
            </div>
          </div> : null }
        </div> : <div className="LeadSourceTablet__content-sec--data-empty">
          <div className="LeadSourceTablet__content-sec--money"/><div>This is where you will be able to see your earnings from successfully closed transactions.</div>
        </div> }
      </div>

      <div className="LeadSourceTablet__footer-sec">
        <span>View Details <i className="fa fa-arrow-right"/></span>
      </div>
      <ReactTooltip />
    </div>
  )
}

const FILTER_KEYS = ['source', 'stage', 'market', 'state', 'zipcode', 'likelihood', 'client', 'price', 'agent', 'timeframe', 'lead_type']
const FILTER_TYPE_OPTIONS = [
  {value: 'source', label: 'Source Name'},
  {value: 'stage', label: 'Stage'},
  {value: 'market', label: 'Market'},
  {value: 'state', label: 'State'},
  {value: 'zipcode', label: 'Zipcode'},
  {value: 'likelihood', label: 'Client Time Frame'},
  {value: 'client', label: 'Client Category'},
  {value: 'price', label: 'Price Range'},
  {value: 'agent', label: 'Agent Name'},
  {value: 'timeframe', label: 'Time Period'},
  {value: 'lead_type', label: 'Lead Type'},
]

class LeadSources extends Component {

  constructor(props) {
    super(props)

    this.state = {
      sort: 'created_at',
      sort_direction: 'desc',
      filters: [{filter_type: 'timeframe', filter_value: 'month'}],
      activeFilters: [{filter_type: 'timeframe', filter_value: 'month'}],
      unusedFilters: FILTER_KEYS.filter(filter => filter.value !== 'timeframe'),
      dirty: false,
      exclude_duplicates: true,
      show_inactive: false,
      options: {
        stage: BROKER_LEAD_STAGES,
        likelihood: SHORT_LEAD_TYPE,
        client: BUYER_TYPE,
        price: PRICE,
        timeframe: LEAD_SOURCE_EXPORT_TIMEFRAME,
        lead_type: LEAD_TYPE_OPTIONS,
        agent: [{value: "waiting-for-agents", label:"Waiting for agents..."}],
        source: [{value: "waiting-for-sources", label:"Waiting for sources..."}],
      }
    }

    this.downloader = new GenericLeadsDownloader()

    this.handleClickForSegmentEvent = this.handleClickForSegmentEvent.bind(this)
    this.handleLeadSourcesExport = this.handleLeadSourcesExport.bind(this)
    this.addFilter = this.addFilter.bind(this)
    this.removeFilter = this.removeFilter.bind(this)
    this.updateFilterType = this.updateFilterType.bind(this)
    this.updateFilterValue = this.updateFilterValue.bind(this)
    this.search = this.search.bind(this)
    this.handleFilter = this.handleFilter.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
  }

  componentWillMount() {
    this.props.dispatch(fetchSourceTypes())
    .then(response => {
      const { options } = this.state
      this.setState({
        options: {
          ...options,
          source: response.source_types.map(source_type => {
            return {value: source_type.id, label: source_type.name}
          })
        }
      })
    })

    this.props.dispatch(fetchStates())
    .then(response => {
      const { options } = this.state
      this.setState({
        options: {
          ...options,
          state: response.states.map(state => {
            return {value: state, label: labelFor(US_STATES, state)}
          })
        }
      })
    })

    this.props.dispatch(fetchMarkets())
      .then(response => {
        const { options } = this.state
        this.setState({
          options: {
            ...options,
            market: response.markets.map(market => {
              return {value: market.id, label: market.name}
            })
          }
        })
      })

    this.props.dispatch(fetchAgents())
      .then(response => {
        let agentOptions = response.agents.map(agent => {
          return {value: agent.id, label: agent.name}
        })
        const { options } = this.state
        agentOptions.unshift({value:'network',label:'Network'})

        this.setState({
          options: {
            ...options,
            agent: agentOptions
          },
          extraForSegment: {
            ...this.state.extraForSegment,
            agentUserHash: response.agents.map(agent => {
              return { id: agent.id, userHash: agent.user_hash }
            })}
        })
      })
  }

  excludeDuplicates = e => this.setState({exclude_duplicates: e.target.checked})

  addFilter() {
    this.setState({
      filters: [...this.state.filters].concat({filter_type: null, filter_value: null})
    })
    this.updateFilterType(this.state.filters.length, this.state.unusedFilters[0])
  }

  removeFilter(idx) {
    let filters = [...this.state.filters]

    filters.splice(idx, 1)
    let newActiveFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))

    this.setState({
      filters,
      unusedFilters,
      activeFilters: newActiveFilters,
      dirty: true
    })
  }

  updateFilterType(idx, filter_type) {
    let filters = [...this.state.filters]
    filters[idx] = {
      filter_type,
      filter_value: null
    }
    let unusedFilters = FILTER_KEYS.filter(val => filters.every(filter => filter.filter_type!==val))
    this.setState({
      filters,
      unusedFilters
    })
  }

  updateFilterValue(idx, filter_value, run_search = false) {
    const search_callback = run_search ? this.handleFilter : null
    let filters = [...this.state.filters]
    filters[idx]['filter_value'] = filter_value
    let activeFilters = filters.filter(filter => filter.filter_type && filter.filter_value)
    this.setState({
      filters,
      activeFilters,
      dirty: true
    }, search_callback)
  }

  handleFilter = _.debounce(() => { this.search() }, 2000)

  handleSearch = _.debounce((searchTerm) => {
    this.setState({searchTerm})
    this.search(searchTerm)
  }, 800)

  search(term) {
    const activeFilters = getQueriesFromFilterList(this.state.activeFilters)
    this.downloader.initializeSearchState()
    if (term || !!this.state.searchTerm || activeFilters.length > 0) {
      term = term || this.state.searchTerm
      this.props.dispatch(searchLeadSources(getTimeframeFromFilterList(this.state.activeFilters), term, activeFilters, this.state.exclude_duplicates))
        .then(() => this.setState({searching: false})).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    } else {
      this.props.dispatch(fetchLeadSources(getTimeframeFromFilterList(this.state.activeFilters), this.state.exclude_duplicates))
        .then(() => this.setState({searching: false})).catch((error) => {
          this.downloader.searchTimedOut()
          throw error
        })
    }
    const filteredFilters = filtersWithValues(this.state.filters)
    this.setState({searching: true, dirty: false, filters: filteredFilters})
  }

  renderLeadSource = (leadSource, idx) => {
    return (
      <div className="col-xs-4 LeadSources__tablets--wrapper" key={idx}>
        <LeadSourceTablet {...leadSource} dispatch={this.props.dispatch} spilloverEnabled={this.props.account.spillover_enabled} leadSourceArrayIdx={idx} />
      </div>
    )
  }

  renderLoadingState = () => {
    return (
      <div>
        <div className="col-xs-4">
          <div className="LeadSources__dummy-loader pulse"></div>
        </div>
        <div className="col-xs-4">
          <div className="LeadSources__dummy-loader pulse"></div>
        </div>
        <div className="col-xs-4">
          <div className="LeadSources__dummy-loader pulse"></div>
        </div>
      </div>
    )
  }

  handleLeadSourcesExport = () => {
    const { activeFilters, extraForSegment, exclude_duplicates } = this.state
    const agentFilter = activeFilters.find(filterEntry => filterEntry.filter_type === 'agent')

    const agentUserHashArray = extraForSegment ? extraForSegment.agentUserHash : []
    const foundAgent = agentFilter && agentUserHashArray.find(agent => agent.id === agentFilter.filter_value)
    const agentUserHash = agentFilter && foundAgent && foundAgent.userHash


    const baseSegmentProperties = {
      'downloaded_data': 'lead_sources',
      'search_filters_exclude_duplicates': exclude_duplicates,
      'timed_out': this.downloader.searchTimeout
    }

    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      activeFilters,
      agentUserHash && { 'agent': agentUserHash }
    )

    segmentEventTracker('Data Downloaded',{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport
    })

    this.downloader.download({
      ...this.state,
      exportUrl: '/download/lead_sources',
      auth: this.props.auth, email: this.props.email, dispatch: this.props.dispatch, account: this.props.account
    })
  }

  handleClickForSegmentEvent = (item, eventName, otherSegmentProperties) => {
    const { activeFilters, exclude_duplicates } = this.state

    const baseSegmentProperties = {
      'transaction_agent_user_hash': item.agent_user_hash,
      'transaction_likelihood_category': item.likelihood_category,
      'lead_inquiry_stage': item.stage,
      'lead_inquiry_external_id': item.primary_lead_inquiry_hash,
      'lead_inquiry_is_duplicate': item.is_duplicate,
      'lead_inquiry_transactions': item.transaction,
      'lead_inquiry_owned_by_brokerage': item.owns_lead,
      'lead_inquiry_price_category': item.price_category,
      'lead_inquiry_client_category': item.client_category,
      'search_filters_exclude_duplicates': exclude_duplicates,
      'lead_source_name': item.source,
      'lead_source_type': item.source_type
    }


    const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
      FILTER_TYPE_OPTIONS,
      activeFilters,
      { 'agent': item.agent_user_hash }
    )

    segmentEventTracker(eventName,{
      ...baseSegmentProperties,
      ...searchFiltersForSegmentExport,
      ...otherSegmentProperties
    })
  }

  render() {
    const { props, state } = this
    const { root } = props
    const { isLoading } = root
    const { account={}, dispatch } = this.props
    const { lead_source_stats } = account

    const defaultNav = {next_page: null, prev_page: null, page_number: 1}
    const useNav = {...defaultNav, ...(_.get(props, 'account.nav', {}))}
    const timeFrameFilter = getTimeFrameFilter()
    const timeFrameOptions = state.options.timeframe

    function getTimeFrameFilter() {
      let timeFrame= {filter_type: 'timeframe', filter_value: 'all'}
      if(state) {
        const timeFrameFromFilter = state.filters.find((filter) => filter.filter_type === "timeframe")
        timeFrame = timeFrameFromFilter ? timeFrameFromFilter : timeFrame
      }
      return timeFrame
    }

    function getPage(forward) {
        const { activeFilters, exclude_duplicates, searchTerm } = state
        let newNav = {
          'page_number': forward ? useNav.page_number + 1: useNav.page_number - 1,
          'page_key': forward ? useNav.next_page : useNav.prev_page,
        }
        props.dispatch(searchLeadSources(getTimeframeFromFilterList(activeFilters), searchTerm, activeFilters, exclude_duplicates, newNav))
    }

    function forward() {
      getPage(true)
    }

    function backward() {
      getPage(false)
    }

    const CancellationNotice = ({account}) => {
      const markedCanceledAt = new Date(account.marked_canceled_at)

      let formattedCanceledAtDate = null
      if (account.marked_canceled_at) {
        formattedCanceledAtDate = markedCanceledAt.getMonth() + 1 + '/' + markedCanceledAt.getDate() + '/' + markedCanceledAt.getFullYear()
      }

      return formattedCanceledAtDate ?
        <div className="LeadSources__canceled-warning"><div className='LeadSources__canceled-warning--icon'><i className="fa fa-exclamation-triangle"></i></div> Your BLA account was canceled on {formattedCanceledAtDate} and we are no longer processing new leads that you send to us. We will continue working the leads that you&#39;ve sent us prior to the cancellation date and will continue to offer any referrals from those leads to agents in your brokerage who are interested.</div>
        : <noscript/>
    }

    const renderRow = (item, idx) => {
      const isDupe = item.is_duplicate
      if (state.exclude_duplicates && isDupe) {
        return null
      }
      const logoClasses = ['LeadSourceTablet__title-sec--logo', `LeadSourceTablet__title-sec--logo--${item.source_key}`]

      return <tr key={idx}>
        <td style={{width: 60, verticalAlign:'middle'}}>
          <div className={logoClasses.join(' ')}>
            <div style={{backgroundImage: `url(${item.logo_url})`}}>{!item.logo_url ? <div>OS</div> : null }</div>
          </div>
        </td>
        <td style={{width: 223}}>
          <div>{ moment.utc(item.arrived_at).local().format("MM-DD-YY h:mm A") }</div>
          <div>{ item.source }</div>
        </td>
        <td style={{width: 248}}>
          <div>{ item.name }</div>
          <div className="LeadSources__small">{ item.email ? item.email : 'No Email Address' }</div>
          <div className="LeadSources__small">{ item.phone ? item.phone : 'No Phone Number' }</div>
          { item.client_category ? <div>{ labelFor(BUYER_TYPE, item.client_category) }</div> : null }
        </td>
        <td style={{width: 168}}>
          <div>{ item.market }</div>
          { item.zipcode ? <div className="LeadSources__small">Zip: { item.zipcode }</div> : null }
          { item.price_category ? <div className="LeadSources__small">Price: { labelFor(PRICE, item.price_category) }</div> : null }
          { item.likelihood_category ? <div className="LeadSources__small">{ labelFor(LEAD_TYPE, item.likelihood_category) }</div> : null }
        </td>
        <td style={{width: 268}}>
          <div>{ !isDupe ? item.stage : 'Duplicate' }{ !isDupe && item.stage == 'Referred' && item.network_referral ? ' (Network)' : '' }</div>
          { isDupe && item.primary_lead_inquiry_arrived_at ? <div className="LeadSources__small">Original at { moment.utc(item.primary_lead_inquiry_arrived_at).local().format("MM-DD-YY h:mm A") }</div> : null }
          { !isDupe ? <div className="LeadSources__small">{ item.resolution }</div> : null }
          { !isDupe && item.transactions && !item.network_referral ? <div className="LeadSources__small">{ item.transactions } Assigned Transaction(s)</div> : null }
          { !isDupe && item.pending_close_transactions && !item.network_referral ? <div className="LeadSources__small">{ item.pending_close_transactions } Closed Transaction(s) (Pending Payment)</div> : null }
          { !isDupe && item.paid_close_transactions && !item.network_referral ? <div className="LeadSources__small">{ item.paid_close_transactions } Closed Transaction(s) (Paid)</div> : null }
          { !isDupe && item.released_transactions && !item.network_referral ? <div className="LeadSources__small">{ item.released_transactions } Released Transaction(s)</div> : null }
          { !isDupe && item.transactions && item.network_referral ? <div className="LeadSources__small">{ item.transactions } Assigned Transaction(s) (Network)</div> : null }
          { !isDupe && item.paid_close_transactions && item.network_referral ? <div className="LeadSources__small">{ item.paid_close_transactions } Closed Transaction(s) (Network)</div> : null }
          { !isDupe && item.release_agent_name ? <div className="LeadSources__small">Released by { item.release_agent_name }</div> : null }
        </td>
        <td style={{width: 263}}>
          <div>{ item.agent_name }</div>
          { item.agent_email ? <div className="LeadSources__small">{ item.agent_email }</div> : null }
          { item.agent_phone ? <div className="LeadSources__small">{ item.agent_phone }</div> : null }
          { item.agent_id ? <a onClick={() => {
            this.handleClickForSegmentEvent(item, 'Sub-User Masqueraded', {
              'masqueraded_user_hash': item.agent_user_hash
            })

            props.dispatch(masqueradeAgent(item.agent_id)).then(response => {
              window.open(response.url, '_blank')
            })
          }}>Login As Agent <i className="fa fa-arrow-circle-right" /></a> : null
          }
        </td>
        <td style={{verticalAlign:'middle'}}>
          <a onClick={() => {
            this.handleClickForSegmentEvent(item, 'Modal Shown', {
              'modal_name': 'LeadInquiryInfoModal'
            })

            const searchFiltersForSegmentExport = exportSearchFiltersForSegment(
              FILTER_TYPE_OPTIONS,
              this.state.activeFilters,
              { 'agent': item.agent_user_hash }
            )

            dispatch(showModal('LeadInquiryInfoModal', {
              initialState: {lead_inquiry_hash: item.lead_inquiry_hash},
              searchFiltersForSegmentExport: searchFiltersForSegmentExport,
              excludeDuplicates: this.state.exclude_duplicates,
              ...item
            }))
          }}>View Details <i className="fa fa-arrow-circle-right"/></a>
        </td>
      </tr>
    }


    if (lead_source_stats) {
      Object.keys(lead_source_stats).filter(type_id => {
        lead_source_stats[type_id]['lead_source_type_id'] = type_id
      })
    }

    return <div>
      <CancellationNotice {...this.props} />
      <div className='LeadSources'>
        { account.feature_flags && !account.feature_flags.hide_lead_source_dashboard ?
          <div className="LeadSources__tablets">
            <div className="LeadSources__tablets--check"><label><input type="checkbox" checked={this.state.show_inactive} onChange={e => this.setState({show_inactive: e.target.checked})}/> Show Inactive</label></div>
            { lead_source_stats ? Object.keys(lead_source_stats)
                .filter(source => (lead_source_stats[source].all_time_summary && lead_source_stats[source].all_time_summary.lead_count && (this.state.show_inactive || lead_source_stats[source].is_active)))
                .sort((a, b) => (lead_source_stats[a].ecr < lead_source_stats[b].ecr))
                .map((key, idx) => this.renderLeadSource(lead_source_stats[key], idx)) : this.renderLoadingState() }
          </div> : null }
          <FilteredList
            checkboxOptions={{excludeDuplicates: { onChange: this.excludeDuplicates, toggled: this.state.exclude_duplicates}}}
            dirty={this.state.dirty}
            filters={this.state.filters}
            filterOptions={this.state.options}
            isLoading={isLoading}
            maxLengthReached={Object.keys(this.state.options).length == (Object.keys(this.state.filters).length)}
            nav={useNav}
            timeFrameFilter={timeFrameFilter}
            timeFrameOptions={timeFrameOptions}
            typeOptionsConsts={FILTER_TYPE_OPTIONS}
            unusedFilters={this.state.unusedFilters}
            onAddFilter={this.addFilter}
            onApply={this.handleFilter}
            onExport={this.handleLeadSourcesExport}
            onPageForward={forward}
            onPageBackward={backward}
            onRemoveFilter={this.removeFilter}
            onSearch={this.handleSearch}
            onUpdateFilterType={this.updateFilterType}
            onUpdateFilterValue={this.updateFilterValue}
          >
          <div className="col-xs-12 LeadSources__bottom-padded-only">
            <Table>
              <thead>
                <tr>
                  <th style={{width: 60}}>&nbsp;</th>
                  <th style={{width: 223}}>Inquiry Received</th>
                  <th style={{width: 248}}>Client Info</th>
                  <th style={{width: 168}}>Lead Details</th>
                  <th style={{width: 268}}>Stage</th>
                  <th style={{width: 263}}>Assigned Agent</th>
                  <th style={{width: 135}}>&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                { account.lead_sources ? account.lead_sources.map(renderRow) : null }
              </tbody>
            </Table>
          </div>
        </FilteredList>
      </div>
      <LeadSourceDetailModal {...this.props}/>
      <LeadInquiryInfoModal {...this.props}/>
      <DownloadModal {...this.props}/>
    </div>
  }
}

export default LeadSources
